import _toConsumableArray from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["enum"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import MaskedPattern from './pattern.js';
import IMask from '../core/holder.js';
import '../core/change-details.js';
import '../core/utils.js';
import './base.js';
import '../core/continuous-tail-details.js';
import './factory.js';
import './pattern/chunk-tail-details.js';
import './pattern/cursor.js';
import './pattern/fixed-definition.js';
import './pattern/input-definition.js';
import './regexp.js';

/** Pattern which validates enum values */
var MaskedEnum = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(MaskedEnum, _MaskedPattern);
  var _super = _createSuper(MaskedEnum);
  function MaskedEnum(opts) {
    _classCallCheck(this, MaskedEnum);
    return _super.call(this, opts); // mask will be created in _update
  }
  _createClass(MaskedEnum, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      _get(_getPrototypeOf(MaskedEnum.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var _enum = opts.enum,
        eopts = _objectWithoutProperties(opts, _excluded);
      if (_enum) {
        var lengths = _enum.map(function (e) {
          return e.length;
        });
        var requiredLength = Math.min.apply(Math, _toConsumableArray(lengths));
        var optionalLength = Math.max.apply(Math, _toConsumableArray(lengths)) - requiredLength;
        eopts.mask = '*'.repeat(requiredLength);
        if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
        this.enum = _enum;
      }
      _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, eopts);
    }
  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      var _this = this;
      return this.enum.some(function (e) {
        return e.indexOf(_this.unmaskedValue) === 0;
      }) && _get(_getPrototypeOf(MaskedEnum.prototype), "doValidate", this).call(this, flags);
    }
  }]);
  return MaskedEnum;
}(MaskedPattern);
IMask.MaskedEnum = MaskedEnum;
export { MaskedEnum as default };